module.exports = "/shared/img/chosen-balls-background.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/chosen-balls-background.png
// module id = 30
// module chunks = 13